<template>
  <div>
    <text-input :label="label" :value="value" :show-label="showLabel"
                :disabled="disabled" :readonly="readonly" :required="required"
                :input-id="calculatedInputId" :input-name="calculatedInputName" input-type="email" autocomplete="email"
                :validation-errors="validationErrors" @changed="changed" @blur="runMailcheck" @focus="$emit('focus')">
      <template #help-text>
        <small v-if="suggestion" class="text-muted" @click="useSuggestion" v-html="helpText" />
      </template>
    </text-input>
  </div>
</template>

<script>
import { DOMAINS } from '../../forms/mailcheck-config'
import Mailcheck from 'mailcheck'
import { nextTick } from 'vue'
import TextInput from './text-input'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { TextInput },

  mixins: [ WithInputIdAndName ],

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    entityName: {
      type: String,
      required: true
    },
    labelOverride: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    },
    value: {
      type: String,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    return {
      fieldName: 'email',
      suggestion: null
    }
  },

  computed: {
    helpText() {
      if (this.suggestion) {
        // This returns a string that includes a link, like "Did you mean foo@example.com?"
        // where `foo@example.com` is a link with the `.mailcheck-email-suggestion` class.
        return this.i18n.t('components.mailcheck.suggestion_help_html', {suggestion: this.suggestion})
      } else {
        return null
      }
    },

    label() {
      return this.labelOverride || this.i18n.t('activerecord.attributes.user.email')
    }
  },

  methods: {
    changed(newValue) {
      this.$emit('changed', newValue)
    },

    runMailcheck() {
      nextTick(() => {
        Mailcheck.run({
          email: this.value,
          domains: DOMAINS.domains,
          topLevelDomains: DOMAINS.topLevelDomains,
          secondLevelDomains: DOMAINS.secondLevelDomains,

          suggested: (suggestion) => {
            this.suggestion = suggestion.full
          },

          empty: () => {
            this.suggestion = null
          }
        })
      })
    },

    useSuggestion() {
      this.changed(this.suggestion)
      this.suggestion = null
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.mailcheck-email-suggestion) {
  cursor: pointer
}
</style>
